import baseRequest from '../_core/baseRequest';

export default {
    searchCustomers: (searchText, selectedSubCompanyId) => baseRequest.get(`/subCompany/${selectedSubCompanyId}/customers?searchText=${searchText}`),
};